var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',[_c('el-row',[_c('getStartedBanner')],1),_c('el-row',[_c('mainDescription')],1),_c('el-row',[_c('h1',{staticClass:"faq"},[_vm._v("Frequently Asked Questions (FAQ's):")])]),_c('el-row',[_c('faq')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }